import { asyncPostRequest } from '../../../api/requests';

export const registerInterest = async ({ name, email, expertise }) => {
  return await asyncPostRequest('/api/creators/register_creator', { name, email, expertise }, false);
};
